import { ForgotPasswordView } from '#hh/client/components'
import { composePage, isClientSide, pushPageViewEvent } from '#hh/client/lib'

function ForgotPasswordPage() {
	if (isClientSide()) {
		pushPageViewEvent()
	}

	return <ForgotPasswordView />
}

ForgotPasswordPage.getInitialProps = async (ctx) => {
	return {
		messages: ctx.messages,
		locale: ctx.locale,
	}
}

export default composePage({
	public: true,
})(ForgotPasswordPage)